export default __webpack_public_path__ + "static/media/ddsu5168_2p_rs485_gw214.77e12c0f.jpg";